/*
 * CAUTION: This file (and everything in this directory) is marked as noParse
 * in our Webpack configuration. This means it cannot import modules, and that
 * it will not be transpiled to ES5. Do *NOT* use any ES6 features that our
 * supported browsers don't support natively (i.e., IE11 does not support arrow
 * functions).
 */

/**
 * Base implementation for components that contain other components.
 */
(function($) {
  $.component.Component.extend('Container', 'content', {
    _init: function() {
      var props = arguments[0];
      this._childrenToLoad = props.children;
      delete props.children;

      this._super.apply(this, arguments);
      //            this._childrenLoading = {};
    },

    _initDom: function() {
      this._super();

      this.$ct = this._getContainer();
      this.$ct.addClass('socrata-container');
      this._addChildren();
    },

    /**
     * Add a child (or children) to the container.
     *
     * @param child the child to add as properties or Component derivative
     * @param position the node before which the child is added; default is end-of-list
     */
    add: function(child, position) {
      var self = this;

      if ($.isBlank(child)) return;
      if ($.isArray(child)) {
        // Set flag to prevent layout as we recurse into arrays
        if (!this._blockArrange)
          var arrange = this._blockArrange = true;

        // Add the children
        var result = _.map(child.slice(), function(c) {
          return self.add(c, position);
        });

        // Arrange if we're the owners of the arrange block
        if (arrange) {
          this._blockArrange = false;
          this._arrange();
        }

        return result;
      }

      if (!(child instanceof $.component.Component)) {
        child = $.component.create(child, this._componentSet);
      }

      // We want to initialize any functional components, but they go into their own store
      // and not into the DOM
      if (child instanceof $.component.FunctionalComponent) {
        this._funcChildren = this._funcChildren || [];
        this._funcChildren.push(child);
        return null;
      }

      if (!this._visibility) {
        child.hide();
      }

      // Disable spinner aggregation for now, since we've switched to a smaller throbber
      //            var cObj = this;
      //            child.bind('start_loading', function()
      //                {
      //                    cObj._childrenLoading[this.id] = true;
      //                    cObj._adjustLoading();
      //                })
      //                .bind('finish_loading', function()
      //                {
      //                    delete cObj._childrenLoading[this.id];
      //                    cObj._adjustLoading();
      //                });
      child._move(this, position);

      return child;
    },

    //        _adjustLoading: function()
    //        {
    //            var numLoading = _.size(this._childrenLoading);
    //            if (numLoading > 1 && !this._loadingForChildren)
    //            {
    //                this._loadingForChildren = true;
    //                this.each(function(child) { child.suspendLoading(true); });
    //                this.startLoading();
    //            }
    //            else if (numLoading < 2 && this._loadingForChildren)
    //            {
    //                this._loadingForChildren = false;
    //                this.each(function(child) { child.suspendLoading(false); });
    //                this.finishLoading();
    //            }
    //        },

    _addChildren: function() {
      if (!$.isBlank(this._childrenToLoad)) {
        this.add(this._childrenToLoad);
        delete this._childrenToLoad;
      }
    },

    _move: function() {
      this._super.apply(this, arguments);
      this._addChildren();
    },

    /**
     * Callback invoked by children that are newly parented by this container or moved within the container.
     */
    _childMoved: function(child, oldParent, oldPrev, oldNext) {
      // Record keeping -- update first & last
      if (!this.first) {
        this.first = this.last = child;
      } else {
        if (this.first == child) {
          if (child.prev)
            this.first = oldNext;
        } else if (!child.prev)
          this.first = child;

        if (this.last == child) {
          if (child.next)
            this.last = oldPrev;
        } else if (!child.next)
          this.last = child;
      }

      // Synchronize DOM
      if ((oldParent != this || oldNext != child.next) && this._initialized) {
        this._moveChildDom(child);
      }
    },

    /**
     * Callback invoked by children that are no longer parented by this container.
     */
    _childRemoved: function(child, oldPrev, oldNext) {
      // Record keeping -- update first & last
      if (this.first == child)
        this.first = oldNext;
      if (this.last == child)
        this.last = oldPrev;

      // Synchronize DOM
      this._removeChildDom(child);
    },

    /**
     * Synchronize child's position in the DOM.  Allows derivative containers to adjust position.
     */
    _moveChildDom: function(child) {
      if (!this._initialized) {
        if (child._initialized) {
          $(child.dom).detach();
        }
        return;
      }
      if (!child._initialized) {
        child._initDom();
      }

      if ($.subKeyDefined(child, 'next.$dom') && child.next.$dom.parent().index(this.$ct) >= 0) {
        child.next.$dom.parent()[0].insertBefore(child.$dom[0], child.next.$dom[0]);
      } else if (!$.isBlank(this.$ct) && (child.$dom.parent().index(this.$ct) < 0 ||
          child.hasOwnProperty('next') && $.isBlank(child.next))) {
        this.$ct[0].appendChild(child.$dom[0]);
      }

      if (child.$dom.parent().length > 0 && this._rendered && !child._rendered) {
        child._render();
      }

      var cObj = this;
      child.bind('shown', function() {
        cObj._arrange();
      }, this);
      child.bind('hidden', function() {
        cObj._arrange();
      }, this);

      this._arrange();
    },

    /**
     * Remove child from DOM.
     */
    _removeChildDom: function(child) {
      if (!this._initialized)
        return;
      child.$dom.detach();
      child.unbind(null, null, this);
      this._arrange();
    },

    /**
     * Apply a function to all children of this container.  Iteration terminates when the first child returns
     * something other than undefined and that value is returned.
     */
    each: function(fn, scope) {
      var child = this.first;
      while (child) {
        var result = fn.call(scope || this, child);
        if (result !== undefined)
          return result;
        child = child.next;
      }
    },

    /**
     * Map all children of this container based on the result of a function.
     */
    map: function(fn, scope) {
      var result = [];
      this.each(function(child) {
        result.push(fn.call(scope, child));
      });
      return result;
    },

    /**
     * Collect children into an array.
     */
    children: function() {
      return this.map(function(child) {
        return child;
      });
    },

    /**
     * Count the children in the container.
     */
    count: function() {
      var count = 0;
      this.each(function() {
        count++;
      });
      return count;
    },

    /**
     * Recursively apply a function to all descendants of this container.
     */
    visit: function(fn, scope) {
      this.each(function(child) {
        fn.call(this, child);
        if (child.visit)
          child.visit(fn, scope);
      }, scope);
    },

    // Override destroy to propagate to children
    destroy: function() {
      this.empty();
      this._super();
    },

    empty: function() {
      this.each(function(child) {
        delete child.parent;
        child.destroy();
      });
      delete this.first;
      delete this.last;
      if (!$.isBlank(this.$contents)) {
        this.$contents.empty();
      }
      _.each(this._funcChildren, function(c) {
        c.destroy();
      });
      delete this._funcChildren;
    },

    setVisibility: function() {
      var origArgs = arguments;
      this._super.apply(this, origArgs);
      this.each(function(c) {
        c.setVisibility.apply(c, origArgs);
      });
    },

    // Function signature: (start, count, callback)
    fetchChildren: function() {
      // Implement me if you can
    },

    // Override render to render children as well
    _render: function() {
      if (!this._super()) {
        return false;
      }

      this.each(this._moveChildDom.bind(this));

      this._arrange();
      return true;
    },

    // Override to create separate container component
    _getContainer: function() {
      return this.$contents;
    },

    // Override Component._propRead to include children property
    _propRead: function() {
      var properties = this._super();
      var children = this._readChildren();
      if (children)
        properties.children = children;
      return properties;
    },

    // Extension point that retrieves the list of children for property extraction
    _readChildren: function() {
      var children = [];
      this.each(function(child) {
        if (child) children.push(child.properties());
      });
      _.each(this._funcChildren, function(child) {
        if (child) children.push(child.properties());
      });
      return children;
    },

    _shown: function() {
      this._super();
      this.each(function(child) {
        child._shown();
      });
    },

    _hidden: function() {
      this._super();
      this.each(function(child) {
        child._hidden();
      });
    },

    domOrAnyChildrenHidden: function() {
      var domIsBlankOrHidden = $.isBlank(this.$dom) || this.$dom.hasClass('hide');
      var anyChildIsHidden = _.some(this.children() || [], function(child) {
        return (child && child.$dom && child.$dom.hasClass('hide'));
      });
      return domIsBlankOrHidden || anyChildIsHidden;
    },

    // Override Component._propWrite to update children (currently brute replace)
    _propWrite: function(properties) {
      this._super(properties);
      if (properties.children) {
        while (this.first)
          this.first.destroy();
        this.add(properties.children);
      }
    },

    // Override to perform layout beyond simple DOM order
    _arrange: function() {
      this.each(function(child) {
        if (child && child._arrange)
          child._arrange();
      });
      this._super();
      if (!$.isBlank(this.$dom)) {
        this.$dom.trigger('canvas_container_updated');
      }
    },

    _testChildHit: function(child, pos, inSequence) {
      var childOffset = child.$dom.offset();
      return (inSequence && childOffset.top > pos.y) ||
        childOffset.top <= pos.y && childOffset.top + child.$dom.outerHeight(true) >= pos.y;
    },

    _drawDropCursor: function(child, targetOrientation) {
      if ($.isBlank(this._$dropCursor)) {
        this._$dropCursor = $.tag({
          tagName: 'div',
          'class': 'dropCursor'
        });
        this.$dom.append(this._$dropCursor);
      }

      var direction = this._dropCursorDirection();
      this._$dropCursor.removeClass('horizontal vertical hide').addClass(direction);

      var pos = 0;
      var side;
      switch (direction) {
        case 'horizontal':
          side = 'top';
          if (targetOrientation.vPos == 'bottom') {
            pos = child.$dom.outerHeight();
          }
          break;
        case 'vertical':
          side = 'left';
          if (targetOrientation.hPos == 'right') {
            pos = child.$dom.outerWidth();
          }
          break;
      }
      pos += child.$dom.offset()[side] - this.$dom.offset()[side];
      this._$dropCursor.css(side, pos);
    },

    _dropCursorDirection: function() {
      return 'horizontal';
    },

    // Propagate substitution parameter scan
    listTemplateSubstitutions: function(list) {
      this._super(list);
      this.each(function(child) {
        child.listTemplateSubstitutions(list);
      });
    }
  });

  $.component.Container.extend('Horizontal Container', 'content', {
    // Override rendering to add a (eww) clearing element
    _initDom: function() {
      this._super.apply(this, arguments);

      var $clear = this.$dom.children('.socrata-ct-clear');
      if ($clear.length < 1) {
        this.$dom.append('<div class="socrata-ct-clear"></div>');
        $clear = $(this.dom.lastChild);
      } else if (!$clear.is(':last-child')) {
        this.$dom.append($clear);
      }
      this._$clear = $clear;
    },

    // Override child move to wrap child in extra div
    _moveChildDom: function(child) {
      if (!child._initialized) {
        child._initDom();
      }
      if (!child.wrapper) {
        var $w = child.$dom.parent('.component-wrapper');
        if ($w.length < 1) {
          child.wrapper = document.createElement('div');
          child.wrapper.className = 'component-wrapper';
          child.wrapper.appendChild(child.dom);
          child.$wrapper = $(child.wrapper);
        } else {
          child.$wrapper = $w;
          child.wrapper = $w[0];
        }
      }
      if ($.subKeyDefined(child, 'next.$wrapper') &&
        child.next.$wrapper.parent().index(this.$ct) >= 0) {
        child.next.$wrapper.parent()[0].insertBefore(child.$wrapper[0], child.next.$wrapper[0]);
      } else if (!$.isBlank(this._$clear)) {
        this._$clear.parent()[0].insertBefore(child.$wrapper[0], this._$clear[0]);
      } else if (!$.isBlank(this.$ct)) {
        this.$ct[0].appendChild(child.$wrapper[0]);
      }
      if (child.$wrapper.parent().length > 0 && this._rendered && !child._rendered) {
        child._render();
      }

      var cObj = this;
      child.bind('shown', function() {
        cObj._arrange();
      }, this);
      child.bind('hidden', function() {
        cObj._arrange();
      }, this);

      this._arrange();
    },

    // Override child remove to 1.) unwrap child, and 2.) update layout
    _removeChildDom: function(child) {
      if (child.$wrapper) {
        child.$wrapper.detach();
        delete child.wrapper;
        delete child.$wrapper;
        child.unbind(null, null, this);
      }
      this._arrange();
    },

    _arrange: function() {
      var cObj = this;
      if (this._blockArrange) {
        return;
      }

      if (this._initialized) {
        this.$contents.toggleClass('inlineDisplay', !!this._properties.inlineDisplay);
      }

      var visibleChildren = [];
      var totalWeight = 0;
      this.each(function(child) {
        if (child._isHidden || !child._isRenderable()) {
          return;
        }
        visibleChildren.push(child);
        totalWeight += child.properties().weight || 1;
      });

      var pos = 0;
      _.each(visibleChildren, function(child) {
        var isWrapped = $.subKeyDefined(child, '$wrapper');
        if (cObj._properties.inlineDisplay) {
          if (isWrapped) {
            child.$wrapper.css({
              marginLeft: 0,
              width: 'auto'
            });
          }
        } else {
          var weight = child.properties().weight || 1;
          if (isWrapped) {
            child.$wrapper.css({
              marginLeft: -(100 - pos / totalWeight * 100) + '%',
              width: (weight / totalWeight * 100) + '%'
            });
          }
          pos += weight;
        }
      });

      this._super();

      if (visibleChildren.length > 0) {
        $(this.dom).children('first-child').removeClass('first-child');
        $(_.first(visibleChildren).wrapper).addClass('first-child');
      }
    },

    _testChildHit: function(child, pos, inSequence) {
      var childOffset = child.$dom.offset();
      return (inSequence && childOffset.left > pos.x) ||
        childOffset.left <= pos.x && childOffset.left + child.$dom.outerWidth(true) >= pos.x;
    },

    _dropCursorDirection: function() {
      return 'vertical';
    }
  });

  $.extend($.component.Container, {
    /**
     * Wrap a child component in a container.  This is used to create space for new components when performing
     * layout into a space perpendicular to the parent container.
     */
    wrap: function(child, wrapperConfig) {
      var parent = child.parent;
      if (!parent)
        throw new Error('Cannot wrap unparented child');
      var position = child.next;

      parent._blockArrange = true;
      try {
        if (wrapperConfig.weight === undefined)
          wrapperConfig.weight = child.properties().weight;
        var wrapper = $.component.create(wrapperConfig, this._componentSet);
        wrapper.add(child);
        parent.add(wrapper, position);
        parent._blockArrange = false;
        parent._arrange();
      } finally {
        parent._blockArrange = false;
      }

      return wrapper;
    },

    /**
     * The inverse of wrap -- replaces a child's container with the child.
     */
    unwrap: function(child) {
      if (child.prev || child.next)
        throw new Error('Cannot unwrap child with siblings');
      var wrapper = child.parent;
      if (!wrapper)
        throw new Error('Cannot unwrap unparented child');
      var parent = wrapper.parent;
      if (!wrapper)
        throw new Error('Cannot unwrap child with root parent');

      parent._blockArrange = true;
      try {
        parent.add(child, wrapper.next);
        wrapper.destroy();
        parent._blockArrange = false;
        parent._arrange();
      } finally {
        parent._blockArrange = false;
      }
    }
  });
})(jQuery);
